import { useState } from "react";
import { IoClose } from "react-icons/io5";

const ExamplesUpload = ({ referenceImages, setReferenceImages, onNext, onBack }) => {

    function getImageSrc(item) {
        if (!item) return null;

        // New upload
        if (item instanceof File) {
            return URL.createObjectURL(item);
        }

        // Existing image URL
        if (typeof item === "string") {
            return item;
        }

        return null;
    }

    return (
        <div style={styles.wrapper}>
            <h2 style={styles.title}>Show us what you like</h2>

            {/* Logo Upload */}

            <div style={styles.section}>
                <p style={styles.label}>Upload Example Images You Love</p>
                <p style={styles.subText}>
                    Upload 3-5 images that represent the style you want. The AI will learn from these examples to create similar content for you.
                </p>



                <div style={styles.uploadRow}>
                    {/* Uploaded images */}
                    {referenceImages.map((logo, index) => (
                        <div key={index} style={styles.uploadCard}>
                            <img
                                src={getImageSrc(logo)}
                                alt="Logo preview"
                                style={styles.logoPreview}
                            />

                            <button
                                style={styles.removeBtn}
                                onClick={() => {
                                    setReferenceImages((prev) => prev.filter((_, i) => i !== index));
                                }}
                            >
                                <IoClose size={18} color="white" />
                            </button>
                        </div>
                    ))}

                    {/* Add new box (only if < 5) */}
                    {referenceImages.length < 5 && (
                        <div style={styles.uploadCard}>
                            <label style={styles.uploadLabel}>
                                <input
                                    type="file"
                                    accept="image/png, image/jpeg, image/svg+xml"
                                    style={{ display: "none" }}
                                    onChange={(e) => {
                                        if (!e.target.files[0]) return;
                                        setReferenceImages((prev) => [...prev, e.target.files[0]]);
                                    }}
                                />
                                <div style={styles.uploadIcon}>＋</div>
                                <p style={styles.uploadText}>Add Example</p>
                            </label>
                        </div>
                    )}
                </div>

            </div>


            {/* Footer Buttons */}
            <div style={styles.footer}>
                <button onClick={onBack} style={styles.backBtn}>Back</button>
                <button onClick={onNext} style={styles.primaryBtn}>
                    ✨ Complete Setup
                </button>
            </div>
        </div>
    );
};


export default ExamplesUpload;

const styles = {
    wrapper: {
        width: "100%",
        minHeight: "60vh",
        backgroundColor: "#000",
        padding: 32,
        boxSizing: "border-box",
        fontFamily: "Inter, sans-serif",
        color: "#fff",
    },

    title: {
        fontSize: 28,
        fontWeight: 700,
        marginBottom: 28,
        textAlign: 'left'
    },

    section: {
        marginBottom: 28,
    },

    label: {
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 10,
        textAlign: "left",
    },

    subText: {
        fontSize: 14,
        color: "#9CA3AF",
        marginBottom: 16,
        textAlign: "left"
    },

    colorRow: {
        display: "flex",
        gap: 24,
    },

    colorInputWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 12,
    },

    colorBox: {
        width: 44,
        height: 44,
        borderRadius: 8,
        border: "2px solid #FFFFFF",
        background: "transparent",
        cursor: "pointer",
    },

    colorText: {
        width: 120,
        height: 44,
        borderRadius: 8,
        border: "none",
        padding: "0 12px",
        fontSize: 14,
    },

    optionRow: {
        display: "flex",
        gap: 16,
        flexWrap: "wrap",
    },

    option: {
        background: "#1F2937",
        color: "#FFFFFF",
        padding: "12px 24px",
        borderRadius: 12,
        border: "1px solid #374151",
        cursor: "pointer",
        fontWeight: 500,
    },

    activeOption: {
        background: "#3A2A12",
        color: "#F6A21A",
        padding: "12px 24px",
        borderRadius: 12,
        border: "1px solid #F6A21A",
        fontWeight: 600,
    },

    uploadRow: {
        display: "flex",
        gap: 20,
        marginTop: 12,
    },

    uploadBox: {
        width: 150,
        height: 170,
        background: "#1F2937",
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#9CA3AF",
    },

    addBox: {
        width: 150,
        height: 170,
        background: "#FFFFFF",
        color: "#000000",
        borderRadius: 12,
        border: "2px dashed #F6A21A",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        cursor: "pointer",
    },

    footer: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: 36,
    },

    backBtn: {
        background: "#1F2937",
        color: "#FFFFFF",
        padding: "14px 36px",
        borderRadius: 14,
        border: "none",
        fontSize: 16,
        cursor: "pointer",
    },

    primaryBtn: {
        background: "#F6A21A",
        color: "#000000",
        padding: "14px 36px",
        borderRadius: 14,
        border: "none",
        fontSize: 16,
        fontWeight: 700,
        cursor: "pointer",
    },
    backBtn: {
        background: "#1F2937",
        color: "#FFFFFF",
        padding: "18px 48px",     // 🔥 bigger
        borderRadius: 18,        // 🔥 more rounded
        border: "none",
        fontSize: 18,            // 🔥 larger text
        fontWeight: 600,
        cursor: "pointer",
    },

    primaryBtn: {
        background: "#F6A21A",
        color: "#000000",
        padding: "18px 48px",     // 🔥 bigger
        borderRadius: 18,        // 🔥 more rounded
        border: "none",
        fontSize: 18,            // 🔥 larger text
        fontWeight: 700,
        cursor: "pointer",
    },

    backBtn: {
        flex: 1,                 // 🔥 smaller portion
        background: "#1F2937",
        color: "#FFFFFF",
        height: 56,              // 🔥 fixed height (image-like)
        borderRadius: 16,
        border: "none",
        fontSize: 16,
        fontWeight: 600,
        cursor: "pointer",
    },
    primaryBtn: {
        flex: 2.5,               // 🔥 bigger portion
        background: "#F7941D",
        color: "#000000",
        height: 56,              // same height
        borderRadius: 16,
        border: "none",
        fontSize: 18,
        fontWeight: 700,
        cursor: "pointer",
    },
    footer: {
        display: "flex",
        gap: 20,
        marginTop: 36,
        width: "100%",
    },

    uploadRow: {
        display: "flex",
        gap: 20,
        marginTop: 16,
    },

    uploadCard: {
        width: 160,
        height: 180,
        background: "#1F2937",
        borderRadius: 14,
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    uploadLabel: {
        width: "100%",
        height: "100%",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9CA3AF",
    },

    uploadIcon: {
        fontSize: 32,
        color: "#F6A21A",
        marginBottom: 6,
    },

    uploadText: {
        fontSize: 14,
    },

    logoPreview: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        padding: 16,
        background: "#FFFFFF",
    },

    removeBtn: {
        position: "absolute",
        top: 5,
        right: 5,
        // transform: "translateX(-50%)",
        background: "#FF0707",
        color: "#FFFFFF",
        border: "none",
        borderRadius: '50%',
        padding: "2px 4px",
        fontSize: 12,
        cursor: "pointer",
        //height:24
    },


};

